import { render, staticRenderFns } from "./UserlocationInvitationTable.vue?vue&type=template&id=9a4aaec2&"
import script from "./UserlocationInvitationTable.vue?vue&type=script&lang=js&"
export * from "./UserlocationInvitationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports